import { FC } from 'react';
import { Box, Grid, Popover, Typography } from '@mui/material';
import { ColorItem } from './Score.styled';
import { COLORING_SCHEME } from 'utils/templates/scoringConfig';

interface IProps {
  colors?: string[];
  open: boolean;
  value?: string;
  anchorEl: Element;
  onClose(): void;
  onSelect(color: string): void;
}

// Colors matching the design in the image
export const _colors = Object.keys(COLORING_SCHEME).slice(0, -1);

const ColorPicker: FC<IProps> = (props) => {
  const { colors = _colors, value, anchorEl, open, onSelect, onClose } = props;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          border: '1px solid #E0E0E0',
        },
      }}
    >
      <Box py="16px" px="20px" width="240px">
        <Grid container spacing={1} sx={{ maxWidth: '200px' }}>
          {colors?.map((color, index) => (
            <Grid item xs={2.4} key={index}>
              <ColorItem
                style={{ background: color }}
                onClick={() => onSelect(color)}
                isSelected={value === color}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onSelect(color);
                  }
                }}
                aria-label={`Select color ${color}`}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: '#fff',
                    fontWeight: 600,
                    textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                  }}
                >
                  A
                </Typography>
              </ColorItem>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Popover>
  );
};

export default ColorPicker;
